import React, {useState,useEffect,useContext,useRef} from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import Lang from '../lang/translations';
import Context from '../context/context';
import helpers from '../_helpers/helpersFunction';
import { attivaPush, pushAttivo } from '../firebase/attivaPush';

const config = require("../_helpers/configServizi");


// una card per canale: link se apre un'altra app (Telegram), bottone altrimenti
function Card({ icona, classeIcona, titolo, testo, tag, tagSpento, consigliato, attivo, disabilitato, href, onClick }) {
    const classe = "canale_card" + (consigliato ? " consigliato" : "") + (attivo ? " attivo" : "")
    const azione = attivo ? undefined : onClick

    const contenuto = (<>
        <span className={"canale_icona " + classeIcona}><i className={icona}/></span>
        <span className="canale_testo">
            <b>{titolo} {tag && <i className={"canale_tag" + (tagSpento ? " presto" : "")}>{tag}</i>}</b>
            <span>{testo}</span>
        </span>
        {!disabilitato && <i className={"canale_stato " + (attivo ? "fa fa-check" : "fa fa-chevron-right")}/>}
    </>)

    if(href && !attivo){
        return <a className={classe} href={href} target="_blank" rel="noopener noreferrer" onClick={azione}>{contenuto}</a>
    }
    return <button type="button" className={classe} onClick={azione} disabled={disabilitato}>{contenuto}</button>
}


export default function Pushtelegram() {

    const context = useContext(Context)
    const navigate = useNavigate()
    const [params] = useSearchParams()

    // arrivano dal link nel popup della notifica; senza parametri la pagina e' generica
    const angelId = params.get('da')
    const nome = params.get('nome')

    const { default_folder } = helpers.getCDNfolder()
    const trackerId = localStorage.getItem('trackerId')
    const botName = config.servizi[window.location.hostname].nome_bot
    const numeroWhatsapp = config.servizi[window.location.hostname].numero_whatsapp;
    // Messaggio precompilato con l'email (non abbiamo subito numero di telefono utente -> dobbiamo collegarlo dopo comunicazione con TextYess)
    const messaggioWhatsapp = Lang({ w: "whatsapp_messaggio", page: "telegramPush", var: true, placeholders: { email: context.user_info.email } });
    const ios = helpers.isIOS()
    const installata = helpers.isAppInstallata()

    const [canali, setCanali] = useState({ push: false, telegram: false })   // push = questo browser
    const [fotoOk, setFotoOk] = useState(true)
    const [mostraPassaggi, setMostraPassaggi] = useState(false)
    const [errorePush, setErrorePush] = useState(null)      // 'negato' | 'non_supportato' | 'errore'
    const aggiornaRef = useRef()


    // tiene allineato user_info (da li' dipende il link nel popup) senza aspettare un nuovo login
    function allineaUserInfo(push, telegram){
        const info = context.user_info
        if(helpers.canaliAttivi(info) === (push || telegram)) return

        context.setUser_info({
            ...info,
            notification_data: push ? [{ type: 'firebase_web' }] : [],
            telegramId: telegram ? (info.telegramId ?? true) : null     // basta che non sia null: al popup serve solo sapere che c'e' un canale
        })
    }

    async function aggiornaCanali(){
        const [questoBrowser, server] = await Promise.all([pushAttivo(), helpers.getCanaliNotifiche()])

        setCanali(prev => ({ push: questoBrowser, telegram: server ? server.telegram : prev.telegram }))
        if(server) allineaUserInfo(server.push > 0 || questoBrowser, server.telegram)
    }
    aggiornaRef.current = aggiornaCanali


    async function clickPush(){
        setErrorePush(null)

        // iOS: la push funziona solo se il sito e' aperto dall'icona sulla Home
        if(ios && !installata){
            setMostraPassaggi(!mostraPassaggi)
            return
        }

        helpers.kpiPanel(context, "canali_notifiche_click", "push")
        const esito = await attivaPush()

        if(esito === 'ok'){
            setCanali(prev => ({ ...prev, push: true }))
            allineaUserInfo(true, canali.telegram)
        }else{
            setErrorePush(esito)
        }
    }


    function clickTelegram(){
        helpers.kpiPanel(context, "canali_notifiche_click", "telegram")
    }


    function clickWhatsapp(){
        helpers.kpiPanel(context, "canali_notifiche_click", "whatsapp");
    }


    function tornaInChat(){
        navigate(angelId ? '/chats/' + angelId : '/chats')
    }


    useEffect(() => {
        helpers.kpiPanel(context, "canali_notifiche_view", angelId ? "da_popup" : "da_menu")
        aggiornaRef.current()

        // chi torna da Telegram trova il canale gia' attivo
        const alRitorno = () => { if(document.visibilityState === 'visible') aggiornaRef.current() }
        document.addEventListener('visibilitychange', alRitorno)
        return () => document.removeEventListener('visibilitychange', alRitorno)
    },[]);


    const haCanale = canali.push || canali.telegram
    const iniziale = nome ? nome.charAt(0).toUpperCase() : null

    const cardPush = (
        <Card key="push"
            icona="fa fa-bell" classeIcona="push"
            titolo={<Lang w={"push_titolo"} page={"telegramPush"}/>}
            testo={<Lang w={canali.push ? "push_attivo" : (ios && !installata ? "push_ios" : "push_testo")} page={"telegramPush"}/>}
            tag={!ios && !canali.push && <Lang w={"consigliato"} page={"telegramPush"}/>}
            consigliato={!ios}
            attivo={canali.push}
            onClick={clickPush}/>
    )

    const cardTelegram = (
        <Card key="telegram"
            icona="fab fa-telegram-plane" classeIcona="telegram"
            titolo="Telegram"
            testo={<Lang w={canali.telegram ? "telegram_attivo" : "telegram_testo"} page={"telegramPush"}/>}
            tag={ios && !canali.telegram && <Lang w={"consigliato"} page={"telegramPush"}/>}
            consigliato={ios}
            attivo={canali.telegram}
            href={"https://t.me/" + botName + "?start=" + trackerId}
            onClick={clickTelegram}/>
    )

    // Whatsapp attivo solo sui servizi con il numero di TextYess nel config, altrimenti "presto"
    const cardWhatsapp = numeroWhatsapp ? (
        <Card
            key = "whatsapp"
            icona = "fab fa-whatsapp" classeIcona="whatsapp"
            titolo = "WhatsApp"
            testo = {<Lang w = {"whatsapp_testo"} page = {"telegramPush"}/>}
            href = {"https://wa.me/" + numeroWhatsapp + "?text=" + encodeURIComponent(messaggioWhatsapp)}
            onClick = {clickWhatsapp}
        />
    ) : (
        <Card 
            key="whatsapp"
            icona="fab fa-whatsapp" classeIcona="whatsapp"
            titolo="WhatsApp"
            testo={<Lang w={"whatsapp_testo"} page={"telegramPush"}/>}
            tag={<Lang w={"presto"} page={"telegramPush"}/>}
            tagSpento={true}
            disabilitato={true}
        />
    )


    return (
        <div className="container padding_bottom filters-padding canali_page">

            <div className="canali_hero">
                {angelId && fotoOk
                    ? <img className="canali_ava" alt="" src={process.env.REACT_APP_CDN + "/" + default_folder + "/" + angelId + ".jpg"} onError={() => setFotoOk(false)}/>
                    : <div className="canali_ava">{iniziale || <i className="fa fa-bell"/>}</div>}

                <h2>
                    {nome
                        ? <Lang var={true} w={"titolo_nome"} page={"telegramPush"} placeholders={{ nome: nome }}/>
                        : <Lang var={true} w={"titolo"} page={"telegramPush"}/>}
                </h2>
                <p><Lang var={true} w={"sottotitolo"} page={"telegramPush"}/></p>
            </div>

            <div className="canali_lista">
                {ios ? cardTelegram : cardPush}
                {ios && mostraPassaggi && !installata && (
                    <div className="canali_passaggi">
                        <div><em>1</em><Lang w={"passo_1"} page={"telegramPush"}/></div>
                        <div><em>2</em><Lang w={"passo_2"} page={"telegramPush"}/></div>
                        <div><em>3</em><Lang w={"passo_3"} page={"telegramPush"}/></div>
                    </div>
                )}
                {ios ? cardPush : cardTelegram}
                {errorePush && <p className="canali_errore"><Lang w={"push_" + errorePush} page={"telegramPush"}/></p>}
                {cardWhatsapp}
            </div>

            {haCanale && <p className="canali_fatto"><Lang w={"fatto"} page={"telegramPush"}/></p>}

            <button type="button" className={"canali_torna" + (haCanale ? " attivo" : "")} onClick={tornaInChat}>
                <i className="fa fa-comments"/>
                {nome
                    ? <Lang var={true} w={"torna_chat_nome"} page={"telegramPush"} placeholders={{ nome: nome }}/>
                    : <Lang var={true} w={"torna_chat"} page={"telegramPush"}/>}
            </button>

        </div>
    )

}
